<div class="d-flex align-items-center justify-content-between mb-2">
    <h4>Landing Page Design</h4>

    <div class="d-flex">
        <button
            class="btn btn-outline-secondary mb-1 me-2"
            type="button"
            *ngIf="!undoDisable"
            (click)="undo()"
        >
            {{'workflow-form.undoLabel' | translate}}
        </button>

        <button
            class="btn btn-outline-secondary mb-1 me-2"
            type="button"
            (click)="onCancel.emit(); $event.stopPropagation();"
        >
            <icon-delete />
            {{ 'sms-content-form.cancelLabel' | translate }}
        </button>

        <button
            class="btn btn-outline-primary mb-1"
            type="button"
            [disabled]="saveDisable"
            (click)="onSave.emit(landingPageForm.value)"
        >
            <icon-save />
            {{ 'sms-content-form.saveLabel' | translate }}
        </button>
        
    </div>
</div>

<div class="card">
    <form class="card-body" [formGroup]="landingPageForm">
        <mat-tab-group 
            mat-stretch-tabs="false" 
            mat-align-tabs="start" 
            (selectedIndexChange)="onTab($event)" 
            [selectedIndex]="selectedTabIndex"
        >
            <mat-tab *ngIf="sentimentCheckEnable">
                <ng-template mat-tab-label>
                    <div ngbTooltip="Your contacts can pick an option to express their satisfaction level with their experience, letting the system suggest them to leave a feedback message or a review."
                    container="body">
                        <span [ngClass]="landingPageForm.dirty && landingPageForm.invalid ?'no-valid' : ''">Sentiment Check Selection</span>
                    </div>
                </ng-template>

                <div class="mt-3">
                    <p-editor formControlName="wyswygSentimentCheck" [style]="{'height':'320px'}">
                        <p-header>
                            <text-editor [options]="toolbarOptions"></text-editor>
                        </p-header>
                    </p-editor>
                    <div class="row" *ngIf="sentimentCheckType=='faces'">
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Happy Face Button Text *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show on happy face">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="happyFaceText"
                                    name="happyFaceText" id="happyFaceText"
                                    placeholder="Happy Face text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('happyFaceText').dirty && landingPageForm.get('happyFaceText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Neutral Face Button *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show on neutral face">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="neutralFaceText"
                                    name="neutralFaceText" id="neutralFaceText"
                                    placeholder="Neutral Face text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('neutralFaceText').dirty && landingPageForm.get('neutralFaceText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Sad Face Button *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show on sad face">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="sadFaceText"
                                    name="sadFaceText" id="sadFaceText"
                                    placeholder="Sad Face text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('sadFaceText').dirty && landingPageForm.get('sadFaceText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="sentimentCheckType=='thumbs'">
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Thumbs Up Text *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show on thumbs up">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="thumbsUpText"
                                    name="thumbsUpText" id="thumbsUpText"
                                    placeholder="Thumbs Up text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('thumbsUpText').dirty && landingPageForm.get('thumbsUpText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Thumbs Down Text *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show on thumbs down">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="thumbsDownText"
                                    name="thumbsDownText" id="thumbsDownText"
                                    placeholder="Thumbs Down text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('thumbsDownText').dirty && landingPageForm.get('thumbsDownText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="sentimentCheckType=='stars'">
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>One Star Text</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show when mouse hover on one star">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="oneStarText"
                                    name="oneStarText" id="oneStarText"
                                    placeholder="One Star text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('oneStarText').dirty && landingPageForm.get('oneStarText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Two Stars Text *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show when mouse hover on two stars">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="twoStarsText"
                                    name="twoStarsText" id="twoStarsText"
                                    placeholder="Two Stars text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('twoStarsText').dirty && landingPageForm.get('twoStarsText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Three Stars Text *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show when mouse hover on three stars">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="threeStarsText"
                                    name="threeStarsText" id="threeStarsText"
                                    placeholder="Three Stars text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('threeStarsText').dirty && landingPageForm.get('threeStarsText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Four Stars Text *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show when mouse hover on four stars">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="fourStarsText"
                                    name="fourStarsText" id="fourStarsText"
                                    placeholder="Four Stars text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('fourStarsText').dirty && landingPageForm.get('fourStarsText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="input-section">
                                <span>Five Stars Text *</span>
                                <div style="display:flex;align-items: center;justify-content: center;"
                                ngbTooltip="Text to show when mouse hover on five stars">
                                    <i class="fas info-icon fa-info-circle"></i>
                                </div>
                            </div>
                            <div style="margin-left: 15px">
                                <input
                                    formControlName="fiveStarsText"
                                    name="fiveStarsText" id="fiveStarsText"
                                    placeholder="Five Stars text"
                                    type="text"
                                    class="form-control"
                                    [ngClass]="landingPageForm.get('fiveStarsText').dirty && landingPageForm.get('fiveStarsText').invalid ?'invalid-field' : ''">
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <div ngbTooltip="Your contacts can choose in which of the Review Targets they are leaving a review or if they prefer to leave a private message for you, according to the workflow specified on sentiment check configuration." 
                    container="body">
                            Review Site Selection
                    </div>
                </ng-template>

                <div *ngIf="landingPageForm.value.showWyswygReviewSite" class="mt-3">
                    <div class="alert alert-danger mt-3" *ngIf="landingPageForm.get('wyswygSentimentCheck').invalid
                    || landingPageForm.get('wyswygReviewSite').invalid">
                        Some of the required placeholders were deleted or modified. Please click on CANCEL or UNDO button to revert the changes and start again.
                    </div>

                    <p-editor formControlName="wyswygReviewSite" [style]="{'height':'400px'}">
                        <p-header>
                            <text-editor [options]="toolbarOptions"></text-editor>
                        </p-header>
                    </p-editor>
                </div>
            </mat-tab>

            <mat-tab *ngIf="enablePrivateFeedback || sentimentCheckEnable" label="Feedback Message Form">
                <ng-template mat-tab-label>
                    <div class="letter-spacing-normal" ngbTooltip="Your contacts can write a private message for you and provide their data to identify them." container="body">
                            Feedback Message Form
                    </div>
                </ng-template>

                <div>
                    <div *ngIf="landingPageForm.value.showWyswygFeedbackMessage" class="mt-3">
                        <div class="alert alert-danger mt-3" *ngIf="landingPageForm.get('wyswygSentimentCheck').invalid
                        || landingPageForm.get('wyswygReviewSite').invalid">
                            Some of the required placeholders were deleted or modified. Please click on CANCEL or UNDO button to revert the changes and start again.
                        </div>

                        <p-editor  formControlName="wyswygFeedbackMessage" [style]="{'height':'200px'}">
                            <p-header>
                                <text-editor [options]="toolbarOptions"></text-editor>
                            </p-header>
                        </p-editor>
                    </div>
                </div>
            </mat-tab>

            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <div class="d-flex d-none">
                        <button
                            class="btn btn-outline-primary"
                            type="button"
                            style="font-weight: 400"
                            *ngxPermissionsOnly="['editLocationsCampaign']"
                            (click)="showPreviewLanding = !showPreviewLanding; $event.stopPropagation();"
                        >
                            <icon-pencil-with-line-2 />
                            Edit
                        </button>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <div class="alert alert-light mt-3">
            <div class="alert-body">
                <div
                    class="d-flex justify-content-between align-items-center"
                    style="margin-top: -10px"
                >
                    <div style="">
                        Please do not remove or modify the following strings:
                    </div>

                    <div>
                        <img class="image" src="https://lh3.googleusercontent.com/-LQp2zR1gu5o/XoPMKhZjenI/AAAAAAAADJA/svlyykQEUv84FvdmIHDfUe3D8wYG8oKNgCK8BGAsYHg/s0/alert-icon-58.png">
                    </div>
                </div>

                <span class="p-holder">Sentiment Check Buttons</span><span>: Placeholder to add sentiment check buttons on landing page</span>
                <br>
                <span class="p-holder">Review Site Buttons</span><span>: Placeholder to add review target buttons on landing page</span>
                <br>
                <span class="p-holder">Review Check us Out Sites</span><span>: Placeholder to add review target buttons with enabled check us out property on landing page</span>
                <br>
                <span  *ngIf="enablePrivateFeedback" class="p-holder">Feedback Button</span><span *ngIf="enablePrivateFeedback">: Placeholder to add feedback button on landing page</span>
            </div>
        </div>
    </form>
</div>
